export default __webpack_public_path__ + "static/media/bronze-medal.b97177bd.svg";